"use client";

import { ModalContent } from "@decibeltrade/web-core/modal";
import { css } from "styled-system/css";
import { stack } from "styled-system/patterns";

import { Skeleton } from "@/components/skeleton";

import { useLazyModalClose } from "../lazy-modal-close";
import { ModalCloseButton } from "../modal-close-button";
import { modalContentStyles } from "./modal-styles";

/**
 * Shown instantly while the modal's chunk downloads and again while its account-overview/positions
 * queries are in flight, so the first open of the session shows a skeleton instead of nothing.
 *
 * `close` comes from context rather than a prop because `next/dynamic` passes nothing to the
 * component it renders while loading — see `lazy-modal-close`.
 */
export function WithdrawModalSkeleton() {
  const close = useLazyModalClose();

  return (
    <ModalContent className={modalContentStyles()}>
      <div className={stack({ gap: "12", w: "full" })}>
        <ModalCloseButton close={close} />
        <Skeleton className={css({ h: "24", w: "[96px]", mx: "auto", borderRadius: "200" })} />
        <Skeleton className={css({ h: "56", w: "full", borderRadius: "300" })} />
        <Skeleton className={css({ h: "56", w: "full", borderRadius: "300" })} />
        <Skeleton className={css({ h: "104", w: "full", borderRadius: "300" })} />
        <Skeleton className={css({ h: "48", w: "full", borderRadius: "300" })} />
      </div>
    </ModalContent>
  );
}
